import styled from 'styled-components';

export const BoxTopbar = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const TopBarUser = styled.div`
  width: 100%;
  text-align: end;
  color: #136033;
  font-weight: bold;
  font-size: 14px;
`;
